/*
 * @author      IRIS Interactive
 * @date        30/08/2023 16:15
 * @copyright   Copyright (c) 2002-2023 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'jquery' // eslint-disable-line
import AjaxService from './services/ajax.service'
import InteractiveMapService from './services/interactive-map.service'

document.addEventListener('DOMContentLoaded', () => {
    new InteractiveMapService()
    new AjaxService()
})
